import Link from '../components/link';
import Glitter from '../movies/glitter.mp4';
import Logo from '../images/negativ-main-logo.webp';

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import '../css/intro.css';

function fadeOut(el, duration = 500) {
  
    return new Promise((resolve) => {
    let done = false;

    const finish = () => {
      if (!done) {
        done = true;
        resolve();
      }
    };

    el.style.transition = `opacity ${duration}ms`;
    el.style.opacity = 0;

    el.addEventListener("transitionend", finish, { once: true });
    setTimeout(finish, duration + 50); // fallback
  });

}

export default function Intro() {

    const navigate = useNavigate();
    const [ready, setReady] = useState(false);

    useEffect(() => {

        const lang = navigator.language;
        const el = document.getElementById("intro-logo");
        
        
        if (ready) {

            const timer = setTimeout(async () => {
                await fadeOut(el, 4000);
                lang.startsWith("pl") ? navigate("/pl/negativ") : navigate("/en/negativ");
            }, 6500);

            return () => clearTimeout(timer);
        }

        

    }, [navigate, ready]);

    return (
        <div className="intro">

            <video autoPlay muted loop playsInline onCanPlayThrough={() => { setReady(true); }}>
                <source src={Glitter} type="video/mp4" />
                Brak obsługi wideo przez Twoją przeglądarkę :-(
            </video>

            <Link to="negativ" classname="intro-link" title="Negativ Fashion Brand!">
                <img src={Logo} alt="Negativ Fashion Brand" className="intro-logo" id="intro-logo" />
                {ready ? <span className="intro-loader done"></span> : <span className="intro-loader"></span>}
            </Link>
            

        </div>
    )

}